import { AsyncSelect } from '@atlaskit/select';

export * from '@atlaskit/select';

export default AsyncSelect;
